import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Calldetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.CALLDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.CALLDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.CALLDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}